<script setup>
import { useRouter } from 'vue-router'
import { currentOrder } from './order-state'
import { clearOrder } from '../s3/document-provider'

const router = useRouter()

const logout = async () => {
  currentOrder.value = null
  clearOrder()
  await router.push({ name: 'Login' })
}
</script>

<template>
  <li class="nav-item dropdown">
    <a
      class="nav-link dropdown-toggle"
      href="#"
      data-bs-toggle="dropdown"
    >
      <i class="bi-list" />
      {{ currentOrder.orderNumber }}
    </a>
    <!-- m-0 to prevent popper warning: -->
    <ul class="dropdown-menu dropdown-menu-end m-0">
      <li>
        <button
          type="button"
          class="dropdown-item"
          @click="logout"
        >
          <i class="bi-box-arrow-right" />
          {{ $t('button.logout') }}
        </button>
      </li>
    </ul>
  </li>
</template>
